import { addTableHeader, drawBody } from "../InvoiceGeneratorUtils";
import { IGeneratePDF_TIKET } from "../generateInvoice.type";

const PDF_TIKET = (data: IGeneratePDF_TIKET) => {
  const header = [
    {
      title: "NO",
      style: {
        width: 10,
      },
    },
    {
      title: "NAMA BARANG",
      style: {
        width: 100,
      },
    },
    {
      title: "SAT",
      style: {
        width: 20,
      },
    },
    {
      title: "QTY",
      style: {
        width: 12,
      },
    },
    {
      title: "TERSEDIA",
    },
  ];

  // Data Table
  const dataTable: any[] = [];
  // data.invoice_detail.forEach((item, index) => {
  //   let temp: any[] = [];
  //   temp.push(index + 1); // No
  //   temp.push(item?.product?.name || "-"); // Nama Barang
  //   temp.push(item.unit_type); // Satuan
  //   temp.push(item?.quantity); // Qty
  //   temp.push(""); // Empty space buat nulis
  //   dataTable.push(temp);
  //   temp = [];
  // });
  data.invoice.forEach((item, index) => {
    let temp: any[] = [];
    temp.push(index + 1); // No
    temp.push(item?.name || "-"); // Nama Barang
    temp.push(item?.unitType); // Satuan
    temp.push(item?.qty); // Qty
    temp.push(""); // Empty space buat nulis
    dataTable.push(temp);
    temp = [];
  });

  const print = (doc: any) => {
    // Variable
    const docWidth = doc.internal.pageSize.width;
    const docHeight = doc.internal.pageSize.height;
    const currentHeight = 15;
    const colorBlack = "#000000";
    const colorGray = "#4d4e53";
    const fieldTextSize = 10;
    const subLineHeight = 4;
    const tdWidth = (doc.getPageWidth() - 20) / header.length;
    const headerTextSize = 20;
    const labelTextSize = 12;
    const lineHeight = 6;

    const pdfConfig = {
      docWidth,
      docHeight,
      currentHeight,
      colorBlack,
      colorGray,
      fieldTextSize,
      subLineHeight,
      header,
      dataTable,
      tdWidth,
      headerTextSize,
      labelTextSize,
      lineHeight,
    };

    // Header
    doc.setFontSize(12);
    doc.text(
      10,
      pdfConfig.currentHeight,
      `NAMA CUSTOMER : ${data.customerName}`
    );
    pdfConfig.currentHeight += 6;
    doc.text(10, pdfConfig.currentHeight, `NAMA TOKO : ${data.shopName}`);
    // pdfConfig.currentHeight += 6;
    // doc.text(
    //   10,
    //   pdfConfig.currentHeight,
    //   `NOMOR PO : ${data?.pre_order_number}`
    // );
    doc.text(200, pdfConfig.currentHeight, `${data.date} `, "right");
    pdfConfig.currentHeight += 3;

    // Table Header
    addTableHeader({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Table Data
    drawBody({ doc: doc, config: pdfConfig });
  };

  return { print };
};

export { PDF_TIKET };
